import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Tiktok24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
  >
    <polygon points="3.63043213 6.06417986 11.6304321 6.06417986 11.6304321 4.56417986 3.63043213 4.56417986"></polygon>
    <polygon points="3.63043213 9.56417986 9.63043213 9.56417986 9.63043213 8.06417986 3.63043213 8.06417986"></polygon>
    <polygon points="3.63043213 13.0641799 8.63043213 13.0641799 8.63043213 11.5641799 3.63043213 11.5641799"></polygon>
    <path
      d="M16.7740836,-0.513289674 L17.3044137,0.0170404119 L18.9733437,1.68597047 L19.1930137,1.90564038 L19.1930137,14.9792644 L14.2275901,14.9792644 L14.2275901,2.03320386 L14.44726,1.81353394 L16.7740836,-0.513289674 Z M16.7735901,1.6073705 L15.7275901,2.6533705 L15.7275901,13.4783705 L17.6925901,13.4783705 L17.6925901,2.5263705 L16.7735901,1.6073705 Z"
      transform="translate(16.7103, 7.233) rotate(-135) translate(-16.7103, -7.233)"
    ></path>
    <polygon points="15.7791443 0.912438833 15.7791443 2.41243883 1.5 2.41243883 1.5 15.2464388 5.38043213 15.2471518 5.38 17.9354388 8.67309415 15.4027261 8.87530202 15.2471518 21.029 15.2464388 21.0291443 9.13384386 22.5291443 9.13384386 22.5291443 16.7471518 9.386 16.7464388 5.08777011 20.0537777 3.88043213 20.9826768 3.88 16.7464388 0 16.7471518 0 0.912438833"></polygon>
  </svg>
);

export default Tiktok24;
